import { createStore } from 'vuex'
import auth from '@/store/auth'
import shared from '@/store/shared'
import pagination from '@/store/pagination'
import templates from '@/store/templates'
import preview from '@/store/preview'
import tree from '@/store/tree'
import images from '@/store/images'
import manualSend from '@/store/manual_send'
import surveys from '@/store/surveys'
import userManagement from '@/store/user_management'
import fromAddresses from '@/store/from_addresses'

export default createStore({
  modules: {
    auth,
    shared,
    pagination,
    templates,
    preview,
    tree,
    images,
    manualSend,
    surveys,
    userManagement,
    fromAddresses
  }
})
